module.exports = __webpack_public_path__ + "static/media/Sucursales.2505c81a.svg";